import React, { FC, useEffect, useState } from 'react';
import { SearchContext, defaultValue } from './Context';
import { useRouter } from 'next/router';
import { IFilterItem } from '@component/search/type';

const SearchProvider: FC = (props) => {
  const router = useRouter();
  const { query } = router;

  // 已选中项对应key-value
  const [selectedOptions, setSelectedOptions] = useState(defaultValue.selectedOptions);
  // 筛选框配置文件
  const [config, setConfig] = useState<IFilterItem[]>(defaultValue.config);
  // 筛选框-城市配置文件
  const [cityConfig, setCityConfig] = useState<IFilterItem[]>(defaultValue.cityConfig);
  // 已经选中的列表数据
  const [selectedList, setSelectedList] = useState(defaultValue.selectedList);
  // 搜索关键词
  const [queryKey, setQueryKey] = useState(defaultValue.queryKey);
  const [pageSize, setPageSize] = useState(defaultValue.pageSize);
  const [pageNum, setPageNum] = useState(defaultValue.pageNum);
  // 排序
  const [sortType, setSortType] = useState(defaultValue.sortType);

  useEffect(() => {
    if (query.key && typeof query.key === 'string') {
      setQueryKey(query.key);
    }
    if (query.sortType && typeof query.sortType === 'string') {
      setSortType(query.sortType);
    }
    if (query.pageNum && typeof query.pageNum === 'string') {
      setPageNum(Number(query.pageNum) || 1);
    }
    setSelectedOptions({
      key: '',
      ...query,
    });
  }, [router.isReady]);

  const result = {
    selectedOptions,
    setSelectedOptions,
    cityConfig,
    setCityConfig,
    config,
    setConfig,
    selectedList,
    setSelectedList,
    queryKey,
    setQueryKey,
    pageNum,
    setPageNum,
    pageSize,
    setPageSize,
    sortType,
    setSortType,
    sortTypeConfig: defaultValue.sortTypeConfig,
  };
  return <SearchContext.Provider value={result}>{props.children}</SearchContext.Provider>;
};
export default SearchProvider;
